import styled from '@emotion/styled';
import { Button as AntButton, Typography } from 'antd';

const { Paragraph } = Typography;

const INITIAL_HEIGHT = '40px';
const INITIAL_WIDTH = '120px';
const INITIAL_FONT_SIZE = '1rem';

export const FilledButton = styled(AntButton)<{
  height?: string;
  width?: string;
  fontSize?: string;
}>`
  height: ${({ height }) => height || INITIAL_HEIGHT};
  width: ${({ width }) => width || INITIAL_WIDTH};
  min-width: ${({ width }) => width || INITIAL_WIDTH};
  font-size: ${({ fontSize }) => fontSize || INITIAL_FONT_SIZE};
  font-weight: bold;
  border-width: 6px;

  .button-text {
    color: inherit;
  }

  &:hover {
    .button-text {
      color: inherit;
    }
  }
`;

export const FilledButtonText = styled(Paragraph)`
  && {
    margin: unset;

    font-size: 1rem;

    @media (max-width: 768px) {
      font-size: 0.875rem;
    }

    @media (max-width: 480px) {
      font-size: 0.625rem;
    }
  }
`;
